module.exports = __webpack_public_path__ + "static/mob-img-5-09b7ae3ea094faf2dcb2d60246367148.png";